<span class="text-muted">{{ 'paged-list-sorter.sort-by' | translate }}</span>
@for (propertyName of propertyNames; track propertyName) {
  <button
    class="ms-1 btn px-1 py-0 btn-sm"
    [class]="sorting[propertyName] === '' ? 'btn-outline-secondary' : 'btn-primary'"
    (click)="sortBy(propertyName)"
    type="button"
  >
    {{ properties[propertyName] | translate }}
    @if (sorting[propertyName] !== '') {
      <span
        ><i class="far" [class]="sorting[propertyName] === 'asc' ? 'fa-sort-up' : 'fa-sort-down'"></i
      ></span>
    }
  </button>
}
